<template>
  <div class="login-wrap">
    <el-form class="login-container" style="display: none" @submit.prevent>
      <h1 class="title">
        {{ languageData.enterGroup }}
      </h1>
      <el-form-item>
        <el-input
          v-model="username"
          type="text"
          :placeholder="languageData.groupName"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item>
                <el-input type="password" v-model="password" placeholder="用户密码" autocomplete="off"></el-input>
            </el-form-item> -->
      <el-form-item>
        <el-button type="primary" style="width: 100%" @click="doLogin">
          {{ languageData.enter }}
        </el-button>
      </el-form-item>
      <!-- <el-row style="text-align: center;margin-top: -10px;">
                <el-link type="primary" @click="doRegister">注册账号</el-link>
                <el-link type="primary" @click="">忘记密码</el-link>
            </el-row> -->
      <!-- <iframe scrolling="no" frameborder="no" border="0" id="UI_Login" name="UI_Login" src="//edu.cocorobo.cn/course/login?type=2" style="border: 0px; width: 100%; height: 100%;"></iframe> -->
    </el-form>
  </div>
</template>

<script>
// import axios from 'axios'
import { ElLoading as Loading } from "element-plus";
import qs from 'qs';
// import bg from "../../assets/bg.png";
import { v4 as uuidv4 } from "uuid";
export default {
  name: "Login",
  emits: ["login","getGroup","getGroupUsers","getTitle","getUserGroup","getData","setRole"],
  data: function () {
    return {
      username: "",
      password: "",
      adminUsername: "Tony",
      adminPassword: "woaixujiawei",
      languageData: {},
      group: [],
      groupUsers: [],
      getUserGroup: [],
    };
  },
  mounted() {
    if (window.location.href.indexOf("cocorobo.cn") != -1) {
      this.languageData = this.zhHansLanguage;
    } else if (window.location.href.indexOf("cocorobo.hk") != -1) {
      this.languageData = this.zhHantLanguage;
    } else if (window.location.href.indexOf("cocorobo.com") != -1) {
      this.languageData = this.enLanguage;
    } else {
      this.languageData = this.zhHansLanguage;
    }

    if (window.location.href.indexOf("cocorobo.cn") != -1) {
      document.domain = "cocorobo.cn";
    } else if (window.location.href.indexOf("cocorobo.hk") != -1) {
      document.domain = "cocorobo.hk";
    } else if (window.location.href.indexOf("cocorobo.com") != -1) {
      document.domain = "cocorobo.com";
    }

    if (
      window.location.href.indexOf("?cid=") != -1 ||
      window.location.href.indexOf("?courseId=") != -1
    ) {
      this.doLogin();
    }
    this.$bus.on("doLogin", () => {
      this.doLogin();
    });
  },
  methods: {
    formatDateTime2(timestamp) {
      const date = new Date(timestamp); // 根据时间戳创建Date对象
      const year = date.getFullYear(); // 获取年份
      const month = date.getMonth() + 1; // 获取月份，需要加1
      const day = date.getDate(); // 获取日期
      const formattedDate = `${year}-${this.handlerZero(
        month
      )}-${this.handlerZero(day)}`; // 拼接成格式化后的日期字符串
      return formattedDate;
    },
    handlerZero(param) {
      return (param = param < 10 ? "0" + param : param);
    },
    doLogin: function () {
      let that = this;
      if (
        window.location.href.indexOf("?cid=") != -1 &&
        window.location.href.indexOf("&gid=") != -1
      ) {
        localStorage.clear();
        let loadingInstance = Loading.service({ fullscreen: true });
        let gid = window.location.href.split("&gid=")[1];
        let cid = window.location.href.split("?cid=")[1].split("&gid=")[0];
        this.$store.commit("set_cid", cid);

        let params = {
          cid: cid,
          classid: 1,
        };
        this.$ajax
          .get("https://pbl.cocorobo.cn/api/pbl/getCourseGroup2", {
            params: params,
          })
          .then((res) => {
            //console.log(res)
            if (res.data[0].length != 0) {
              if(res.data[0][0].group != null) {
                let group = JSON.parse(res.data[0][0].group)
                if(group.publicGroup) {
                  that.enterCourse(cid, gid, loadingInstance);
                }
                else {
                  that.setCourseGroup(cid, gid, loadingInstance, group)
                }
              }
              else {
                let group = {"group": [],"islock": 1,"number": 0}
                that.setCourseGroup(cid, gid, loadingInstance, group)
              }
            }
            // else {
            //   let params = [
            //     {
            //       uid: window.location.href.indexOf("localhost") != -1 || window.location.href.indexOf("192.168") != -1 ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01" : window.parent.US.userInfo.userid,
            //       title: window.location.href.indexOf("localhost") != -1 || window.location.href.indexOf("192.168") != -1 ? '潘炜桐'+that.formatDateTime2(new Date().getTime())+"的快速创建" : window.parent.US.userInfo.username+this.formatDateTime2(new Date().getTime())+"的快速创建",
            //       //title: "黄明浩"+this.formatDateTime2(new Date().getTime())+"的快速创建",
            //       brief: "",
            //       cover:
            //       JSON.stringify([
            //             {
            //               name: "noBanner.jpg",
            //               url: "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/wu1676621845022.png",
            //               uid: 1656409780264,
            //               status: "success",
            //             },
            //           ]),
            //       evaId: "",
            //       astudent:"",
            //       see: 1,
            //       chapters: JSON.stringify([{"dyName":"","chapterInfo":[{"isread":false,"chapterid":"468faf7e-ff3e-c2bf-2829-a78fd5fea04e","title":"","courseName":"","taskJson":[{"task":"","taskDetail":"","chapterData":[],"toolChoose":[{"tool":[],"toolDetail":"","toolType":0,"askCount":1,"askTitle":"","askJson":[{"askstitle":"","askItem":1,"checkList":[]}]}],"toolText":"","isShowTools":false,"askCount":1,"isFold":0,"askTitle":"","askJson":[{"askstitle":"","askItem":1,"checkList":[]}],"checkJson":[{"checkCount":[],"checkPerent":[]}],"homeworkList":[],"proVisible":false,"proVisible2":false}],"itemCount":1,"fileList1":[],"video":[],"testData":[],"pData":[],"templateArray":[]}]}]),
            //       template:  "" ,
            //       courseType: JSON.stringify([]),
            //       ateacher:"",
            //       inviteCode: "[]",
            //     },
            //   ];
            //   that.$ajax
            //     .post("https://pbl.cocorobo.cn/api/pbl/addSynergyCourse", qs.stringify(params))
            //     .then((res) => {
            //       console.log(res);
            //       // this.$message({
            //       //   message: "新增成功",
            //       //   type: "success",
            //       // });
            //       that.enterCourse(cid,gid,loadingInstance)
            //     })
            //     .catch((err) => {
            //       that.$message.error("网络不佳");
            //       console.error(err);
            //     });
            // }
          })
          .catch((err) => {
            console.error(err);
          });

        // let params = {
        //   cid: cid,
        //   classid: 1,
        // };
        // this.$ajax
        //   .get("https://pbl.cocorobo.cn/api/pbl/getCourseGroup2", {
        //     params: params,
        //   })
        //   .then((res) => {
        //     //console.log(res)
        //     let groups = [];
        //     let groupUsers = []
        //     let title = ""
        //     let groupName=""
        //     if (res.data[0].length != 0) {
        //       groups = res.data[0];
        //       that.$store.commit("set_creator",res.data[0][0]);
        //       if(groups[0].group != null) {
        //         that.group = JSON.parse(groups[0].group).group;
        //       }
        //       title = groups[0].title;
        //     }
        //     if (res.data[1].length != 0) {
        //       groupUsers = res.data[1]
        //       that.groupUsers = groupUsers
        //     }
        //     if (gid == "") {
        //       //创建者
        //       that.$store.commit("set_groupUsers",res.data[1])
        //       that.getUserGroup = []
        //       let userid ="";
        //       try{
        //         userid = top.US.userInfo.userid;
        //       }catch{
        //         userid = "1cf9dc4b-d95f-11ea-af4c-52540005ab01";
        //       }
        //       if(userid==res.data[0][0].userid || top?.US?.userInfo.role==1){
        //         //创建者
        //         that.getcscl(cid, loadingInstance,title);
        //         localStorage.setItem("roomId", cid);
        //         that.group.unshift({
        //           id: cid,
        //           name: that.languageData.myGroup,
        //           group_member:[{
        //             username:res.data[0][0].username,
        //             userid:res.data[0][0].userid,
        //             name:res.data[0][0].name,
        //             groupCid:res.data[0][0].courseId,
        //           }]
        //         });
        //         that.$store.commit("set_group_active_id", that.group[0].id)
        //         groupName=that.languageData.myGroup
        //       }else{
        //         //不是创建者没有我的小组
        //         let user = res.data[1].filter(item=>{
        //           return item.userid==userid
        //         })
        //         that.group.forEach(group=>{
        //           if(group.id==user[0].groupCid){
        //             groupName=group.name
        //           }
        //         })
        //         that.$store.commit("set_group_active_id", user[0].groupCid)
        //         that.getcscl(user[0].groupCid, loadingInstance,title);
        //         localStorage.setItem("roomId", user[0].groupCid);
        //       }
        //     }else {
        //       //协同者
        //       let group = []
        //       for(let i = 0;i < that.group.length;i++) {
        //         if(that.group[i].id == gid) {
        //           group.push(that.group[i])
        //           groupName=that.group[i].name;
        //           break
        //         }
        //       }
        //       that.group = group
        //       that.$store.commit("set_group_active_id", that.group[0].id)
        //       localStorage.setItem("roomId", that.group[0].id);
        //     }
        //     that.group.forEach((it) => {
        //       it.group_member_desc = that.languageData.launch;
        //       it.creator={
        //         username:res.data[0][0].username,
        //         userid:res.data[0][0].userid
        //       }
        //       it.group_member_flag = false;
        //       if(!it.group_member){
        //         it.group_member = [];
        //         res.data[1].forEach((item) => {
        //           if (item.groupCid == it.id) {
        //             it.group_member.push(item);
        //           }
        //         });
        //       }
        //     });
        //     that.group.forEach(group=>{
        //       group.character=[];
        //       group.group_member.forEach(group_member=>{
        //         res.data[2].forEach(character=>{
        //           if(group_member.userid==character.userid){
        //             group.character.push(character)
        //           }
        //         })
        //       })
        //     })
        //     that.$store.commit("set_group",that.group)
        //     // console.log(that.group)
        //     if (gid == "") {
        //       that.$emit("getGroup", that.group);
        //       that.$emit("getGroupUsers", that.groupUsers)
        //       that.$emit("getTitle",title)
        //     }
        //     else {
        //       that.$store.commit("set_groupUsers",that.group[0].group_member)
        //       that.getcscl(gid, loadingInstance, title);
        //       // localStorage.setItem("roomId", gid);
        //       that.$emit("getGroup", that.group);
        //       that.$emit("getGroupUsers", that.groupUsers)
        //       that.$emit("getTitle",title)
        //     }
        //     that.$store.commit("set_group_title", groupName)
        //   })
        //   .catch((err) => {
        //     console.error(err);
        //   });

        // if (gid == "") {
        //   let params = {
        //     cid: cid,
        //     classid: 1,
        //   };
        //   this.$ajax
        //     .get("https://pbl.cocorobo.cn/api/pbl/getCourseGroup2", {
        //       params: params,
        //     })
        //     .then((res) => {
        //       let groups = [];
        //       let groupUsers = []
        //       let title = ""
        //       if (res.data[0].length != 0) {
        //         groups = res.data[0];
        //         that.group = JSON.parse(groups[0].group).group;
        //         title = groups[0].title;
        //       }
        //       if (res.data[1].length != 0) {
        //         groupUsers = res.data[1]
        //         // console.log(groupUsers)
        //         that.groupUsers = groupUsers
        //       }
        //       that.group.forEach((it) => {
        //         that.setcscl(it.id, loadingInstance,title)
        //       })
        //       that.group.unshift(
        //         {
        //         id: cid,
        //         name: "我的小组",
        //         }
        //       );
        //       that.group.forEach((it) => {
        //         it.group_member_desc = "展开";
        //         it.group_member_flag = false;
        //         it.group_member = [];
        //         res.data[1].forEach((item) => {
        //           if (item.groupCid == it.id) {
        //             it.group_member.push(item);
        //           }
        //         });
        //       });
        //       that.getcscl(cid, loadingInstance,title);
        //       localStorage.setItem("roomId", cid);
        //       that.$emit("getGroup", that.group);
        //       that.$emit("getGroupUsers", that.groupUsers)
        //       // let currentUserId = window.location.href.indexOf("localhost") != -1 || window.location.href.indexOf("192.168") != -1 ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01" : window.parent.US.userInfo.userid
        //       // for (let i = 0; i < groupUsers.length; i++) {
        //       //   if (groupUsers[i].userid == currentUserId) {
        //       //     this.getcscl(groupUsers[i].groupCid, loadingInstance);
        //       //     break
        //       //   }
        //       // }
        //       // let data = {
        //       //   "nodes": [{ "id": "ecb16218-68b0-47db-a0c2-d5329c75fcf5", "type": "icon-theme", "x": 355, "y": 350, "properties": { "isShowDelete": false, "id": "ecb16218-68b0-47db-a0c2-d5329c75fcf5", "type": "icon-theme", "topic": "起始" }, "zIndex": 1002 }],
        //       //   "edges": [],
        //       //   "backgroundUrl": bg
        //       // }
        //       // this.data = data
        //       // localStorage.setItem("background", bg)
        //     })
        //     .catch((err) => {
        //       console.error(err);
        //     });
        // } else {
        //   let loadingInstance = Loading.service({ fullscreen: true });
        //   that.getcscl(gid, loadingInstance, "");
        //   localStorage.setItem("roomId", gid);
        //   that.group = [];
        //   that.$emit("getGroup", that.group);
        //   that.groupUsers = []
        //   that.$emit("getGroupUsers", that.groupUsers)
        // }
      } else {
        let loadingInstance = Loading.service({ fullscreen: true });
        let params = {
          uid: this.username,
        };
        this.$ajax
          .get("https://pbl.cocorobo.cn/api/pbl/selectRoom", { params: params })
          .then((res) => {
            if (res.data[0].length) {
              // let mindinfo = {
              //     "us.cscl": [{
              //         sendId: window.location.href.indexOf("localhost") != -1 || window.location.href.indexOf("192.168") != -1 ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01" : window.parent.US.userInfo.userid, //发送人id
              //         receiveId:  res.data[0][0].id, //文件id
              //         pageId: window.location.href.indexOf("localhost") != -1 || window.location.href.indexOf("192.168") != -1 ? 'd7300d31-8cf6-38dc-e295-2c71622b4df1' : window.parent.US.pageId,
              //         type: 'delete', //消息类型
              //         messageInfo: {"backgroundUrl":"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/3cd0b494-0659-4c38-be40-52aa7b2ee0b7.png","edges":[{"id":"60439226-57ad-42e8-bb8d-28dfcca29ead","type":"pro-curved","sourceNodeId":"9f6d7459-d376-4c0c-944b-a6b140085903","targetNodeId":"ae9ff688-be94-48bd-846f-5bd92195c93b","startPoint":{"x":625,"y":185},"endPoint":{"x":655,"y":300},"properties":{},"zIndex":1003,"pointsList":[{"x":625,"y":185},{"x":625,"y":242.5},{"x":655,"y":242.5},{"x":655,"y":300}]},{"id":"15593671-f3ab-434a-936d-82589210df3e","type":"pro-line","sourceNodeId":"c159469f-770c-4074-95c3-be401bc78bd9","targetNodeId":"9b8dd5b2-a418-4078-9e23-9bc062d5763a","startPoint":{"x":660,"y":1195},"endPoint":{"x":705,"y":1265},"properties":{},"zIndex":1013}],"nodes":[{"id":"9f6d7459-d376-4c0c-944b-a6b140085903","type":"icon-start","x":625,"y":145,"properties":{},"text":{"x":405,"y":180,"value":"起始"},"zIndex":1002},{"id":"ae9ff688-be94-48bd-846f-5bd92195c93b","type":"icon-card","x":655,"y":425,"properties":{},"zIndex":1002},{"id":"37b9131b-aa9d-4e07-b296-d3f3ed525582","type":"icon-card","x":995,"y":1000,"properties":{"isShowDelete":true,"id":"37b9131b-aa9d-4e07-b296-d3f3ed525582","type":"icon-card"},"zIndex":1002},{"id":"14bc8e92-6824-4a40-b9ac-5373d706cf5c","type":"icon-AI","x":335,"y":645,"properties":{"is_show_user":false,"isShowDelete":true,"id":"14bc8e92-6824-4a40-b9ac-5373d706cf5c","type":"icon-AI"},"zIndex":1002},{"id":"9b8dd5b2-a418-4078-9e23-9bc062d5763a","type":"icon-thinking","x":705,"y":1390,"properties":{"isShowDelete":false,"id":"9b8dd5b2-a418-4078-9e23-9bc062d5763a","type":"icon-thinking","sourceUrlList":[{"name":"","url":"https://cscl.cocorobo.cn/img/%E6%B5%81%E7%A8%8B%E5%88%86%E6%9E%90%E5%9B%BE.8790140b.png"}],"radio":"imageList"},"zIndex":1002}]}
              //     }]
              // }
              // let params = "mode=" + ["send", encodeURIComponent(encodeURIComponent(JSON.stringify(mindinfo)))].join(',');
              // this.$ajax.post("https://poll.cocorobo.cn", params)
              //     .then((res) => {
              //         console.log(res);
              //     })
              //     .catch((err) => {
              //         console.error(err);
              //     })
              this.getcscl(res.data[0][0].id, loadingInstance, "");
              localStorage.setItem("roomId", res.data[0][0].id);
            } else {
              loadingInstance.close();
              this.$message({
                message: this.languageData.tip11,
                type: "error",
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    setCourseGroup(cid, gid, loadingInstance, group) {
      let that = this;
      group.publicGroup = [{
        "name": that.languageData.publicGroup, "id": uuidv4()
      }]
      let params = [
        {
          cid: cid,
          group: JSON.stringify(group),
          classid: 1,
        },
      ];
      that.$ajax
        .post("https://pbl.cocorobo.cn/api/pbl/setCourseGroup", qs.stringify(params))
        .then((res) => {
          console.log(res)
          that.enterCourse(cid, gid, loadingInstance);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    enterCourse(cid, gid, loadingInstance) {
      let that = this;
      let params = {
        cid: cid,
        classid: 1,
      };
      this.$ajax
        .get("https://pbl.cocorobo.cn/api/pbl/getCourseGroup2", {
          params: params,
        })
        .then((res) => {
          //console.log(res)
          let groups = [];
          let groupUsers = [];
          let title = "";
          let groupName = "";
          if (res.data[0].length != 0) {
            groups = res.data[0];
            that.$store.commit("set_creator", res.data[0][0]);
            if (groups[0].group != null) {
              that.group = JSON.parse(groups[0].group).group;
            } else {
              that.group = [];
            }
            title = groups[0].title;
          }
          if (res.data[1].length != 0) {
            groupUsers = res.data[1];
            that.groupUsers = groupUsers;
          }
          else {
            groupUsers = [];
            that.groupUsers = groupUsers;
          }
          if (gid == "") {
            //创建者或者老师协同者账号
            that.$store.commit("set_groupUsers", res.data[1]);
            that.getUserGroup = [];
            let userid = "";
            try {
              userid = top.US.userInfo.userid;
            } catch {
              userid = "1cf9dc4b-d95f-11ea-af4c-52540005ab01";
            }
            if (
              userid == res.data[0][0].userid ||
              top?.US?.userInfo.role == 1
            ) {
              // 创建者或者管理员账号
              that.getcscl(cid, loadingInstance, title);
              localStorage.setItem("roomId", cid);
              that.group.unshift((JSON.parse(groups[0].group).publicGroup)[0]);
              that.group.unshift({
                id: cid,
                name: that.languageData.myGroup,
                group_member: [
                  {
                    username: res.data[0][0].username,
                    userid: res.data[0][0].userid,
                    name: res.data[0][0].name,
                    groupCid: res.data[0][0].courseId,
                  },
                ],
              });
              that.$store.commit("set_group_active_id", that.group[0].id);
              groupName = that.languageData.myGroup;
              that.$emit("setRole", true);
            } else {
              // 老师账号
              let user = res.data[1].filter((item) => {
                return item.userid == userid;
              });
              that.group.forEach((group) => {
                if (group.id == user[0].groupCid) {
                  groupName = group.name;
                }
              });
              that.group.push((JSON.parse(groups[0].group).publicGroup)[0]);
              that.$store.commit("set_group_active_id", user[0].groupCid);
              that.getcscl(user[0].groupCid, loadingInstance, title);
              localStorage.setItem("roomId", user[0].groupCid);
              that.$emit("setRole", false);
            }
          } else {
            // 协同者
            let group = [];
            // 老师账号
            if(top?.US?.userInfo.type == 1) {
              for (let i = 0; i < that.group.length; i++) {
                group.push(that.group[i]);
              }
              groupName = group[0].name;
            }
            // 学生账号
            else if(top?.US?.userInfo.type == 2) {
              if(JSON.parse(groups[0].group).isAllStudentRead && JSON.parse(groups[0].group).isAllStudentEdit) {
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id == gid) {
                    group.push(that.group[i]);
                    break
                  }
                }
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id != gid) {
                    group.push(that.group[i]);
                  }
                }
                groupName = group[0].name;
              }
              else if(JSON.parse(groups[0].group).isAllStudentRead && !JSON.parse(groups[0].group).isAllStudentEdit) {
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id == gid) {
                    that.group[i].isSilentMode = false
                    that.group[i].isShowMode = true
                    group.push(that.group[i]);
                    break
                  }
                }
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id != gid) {
                    that.group[i].isSilentMode = true
                    that.group[i].isShowMode = false
                    group.push(that.group[i]);
                  }
                }
                groupName = group[0].name;
              }
              else {
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id == gid) {
                    group.push(that.group[i]);
                    groupName = that.group[i].name;
                    break;
                  }
                }
              }
            }
            else {
              if(JSON.parse(groups[0].group).isAllStudentRead && JSON.parse(groups[0].group).isAllStudentEdit) {
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id == gid) {
                    group.push(that.group[i]);
                    break
                  }
                }
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id != gid) {
                    group.push(that.group[i]);
                  }
                }
                groupName = group[0].name;
              }
              else if(JSON.parse(groups[0].group).isAllStudentRead && !JSON.parse(groups[0].group).isAllStudentEdit) {
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id == gid) {
                    that.group[i].isSilentMode = false
                    that.group[i].isShowMode = true
                    group.push(that.group[i]);
                    break
                  }
                }
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id != gid) {
                    that.group[i].isSilentMode = true
                    that.group[i].isShowMode = false
                    group.push(that.group[i]);
                  }
                }
                groupName = group[0].name;
              }
              else {
                for (let i = 0; i < that.group.length; i++) {
                  if (that.group[i].id == gid) {
                    group.push(that.group[i]);
                    groupName = that.group[i].name;
                    break;
                  }
                }
              }
            }
            group.push((JSON.parse(groups[0].group).publicGroup)[0]);
            that.group = group;
            that.$store.commit("set_group_active_id", that.group[0].id);
            localStorage.setItem("roomId", that.group[0].id);
            that.$emit("setRole", false);
          }
          that.group.forEach((it) => {
            it.group_member_desc = that.languageData.launch;
            it.creator = {
              username: res.data[0][0].username,
              userid: res.data[0][0].userid,
            };
            it.group_member_flag = false;
            if (!it.group_member) {
              it.group_member = [];
              res.data[1].forEach((item) => {
                if (item.groupCid == it.id) {
                  it.group_member.push(item);
                }
              });
            }
          });
          that.group.forEach((group) => {
            group.character = [];
            group.group_member.forEach((group_member) => {
              res.data[2].forEach((character) => {
                if (group_member.userid == character.userid) {
                  group.character.push(character);
                }
              });
            });
          });
          that.$store.commit("set_group", that.group);
          console.log(that.group)
          if (gid == "") {
            that.$emit("getGroup", that.group);
            that.$emit("getGroupUsers", that.groupUsers);
            that.$emit("getTitle", title);
          } else {
            that.$store.commit("set_groupUsers", that.group[0].group_member);
            that.getcscl(gid, loadingInstance, title);
            // localStorage.setItem("roomId", gid);
            that.$emit("getGroup", that.group);
            that.$emit("getGroupUsers", that.groupUsers);
            that.$emit("getTitle", title);
          }
          that.$store.commit("set_group_title", groupName);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getcscl(id, loadingInstance, title) {
      let that = this;
      let params =
        window.location.href.indexOf("localhost") != -1 ||
        window.location.href.indexOf("192.168") != -1
          ? "mode=" +
            [
              "getcscl",
              id,
              "d7300d31-8cf6-38dc-e295-2c71622b4df1",
              "1cf9dc4b-d95f-11ea-af4c-52540005ab01",
            ].join(",")
          : "mode=" +
            [
              "getcscl",
              id,
              window.parent.US.pageId,
              window.parent.US.userInfo.userid,
            ].join(",");
      this.$ajax
        .post("https://poll.cocorobo.cn", params)
        .then((res) => {
          let data = {};
          localStorage.setItem("user", JSON.stringify(res.data[0][0].user));
          that.$store.commit("set_group_member_active", []);
          that.$store.commit("set_group_member_active", res.data[0][0].user);
          try {
            data = JSON.parse(res.data[0][0].data);
          } catch {
            data = res.data[0][0].data;
          }
          res.data[0][0].data = data;
          that.getUserGroup.push(res.data[0][0]);

          that.$emit("getUserGroup", that.getUserGroup);
          if (data.nodes == null) {
            // localStorage.setItem("data", JSON.stringify({ "nodes": [{ "id": "9f6d7459-d376-4c0c-944b-a6b140085903", "type": "icon-start", "x": 625, "y": 145, "properties": {}, "text": { "x": 405, "y": 180, "value": "起始" }, "zIndex": 1002 }], "edges": [], "backgroundUrl": "img/bg.ccee1c62.png" }))
            let new_id = uuidv4();
            data = {
              nodes: [
                {
                  id: new_id,
                  type: "icon-theme",
                  x: 355,
                  y: 350,
                  properties: {
                    isShowDelete: false,
                    id: new_id,
                    type: "icon-theme",
                    topic: title != "" ? title : "起始",
                  },
                  zIndex: 1002,
                },
              ],
              edges: [],
              backgroundUrl: "",
            };
            let mindinfo = {
              "us.cscl": [
                {
                  sendId:
                    window.location.href.indexOf("localhost") != -1 ||
                    window.location.href.indexOf("192.168") != -1
                      ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                      : window.parent.US.userInfo.userid, //发送人id
                  receiveId: id, //文件id
                  pageId:
                    window.location.href.indexOf("localhost") != -1 ||
                    window.location.href.indexOf("192.168") != -1
                      ? "d7300d31-8cf6-38dc-e295-2c71622b4df1"
                      : window.parent.US.pageId,
                  type: "update", //消息类型
                  messageInfo: data,
                },
              ],
            };
            let params =
              "mode=" +
              [
                "send",
                encodeURIComponent(
                  encodeURIComponent(JSON.stringify(mindinfo))
                ),
              ].join(",");
            this.$ajax
              .post("https://poll.cocorobo.cn", params)
              .then((res) => {
                console.log(res);
              })
              .catch((err) => {
                console.error(err);
                loadingInstance.close();
                that.$message({
                  message: err,
                  type: "error",
                });
              });
            // localStorage.setItem("data", JSON.stringify(data))
            that.$emit("getData", data);
            localStorage.setItem("background", data.backgroundUrl);
          } else {
            let nodes = data.nodes;
            let edges = data.edges;
            let newNodes = [];
            let newEdges = [];
            for (let i = 0; i < nodes.length; i++) {
              if (nodes[i] !== null && typeof nodes[i] === "object") {
                newNodes.push(nodes[i]);
              }
            }
            for (let i = 0; i < edges.length; i++) {
              if (edges[i] !== null && typeof edges[i] === "object") {
                newEdges.push(edges[i]);
              }
            }
            data.nodes = newNodes;
            data.edges = newEdges;
            // localStorage.setItem("data", JSON.stringify(data))
            that.$emit("getData", data);
            localStorage.setItem("background", data.backgroundUrl);
          }
          loadingInstance.close();
          this.$emit("login", 1);
          localStorage.setItem("network", true);
        })
        .catch((err) => {
          console.error(err);
          loadingInstance.close();
          that.$message({
            message: err,
            type: "error",
          });
        });
    },
    setcscl(id, loadingInstance, title) {
      let that = this;
      let params =
        window.location.href.indexOf("localhost") != -1 ||
        window.location.href.indexOf("192.168") != -1
          ? "mode=" +
            [
              "getcscl",
              id,
              "d7300d31-8cf6-38dc-e295-2c71622b4df1",
              "1cf9dc4b-d95f-11ea-af4c-52540005ab01",
            ].join(",")
          : "mode=" +
            [
              "getcscl",
              id,
              window.parent.US.pageId,
              window.parent.US.userInfo.userid,
            ].join(",");
      that.$ajax
        .post("https://poll.cocorobo.cn", params)
        .then((res) => {
          let data = {};
          // localStorage.setItem("user", JSON.stringify(res.data[0][0].user));
          try {
            data = JSON.parse(res.data[0][0].data);
          } catch {
            data = res.data[0][0].data;
          }
          res.data[0][0].data = data;
          that.getUserGroup.push(res.data[0][0]);
          that.$emit("getUserGroup", that.getUserGroup);
          if (data.nodes == null) {
            // localStorage.setItem("data", JSON.stringify({ "nodes": [{ "id": "9f6d7459-d376-4c0c-944b-a6b140085903", "type": "icon-start", "x": 625, "y": 145, "properties": {}, "text": { "x": 405, "y": 180, "value": "起始" }, "zIndex": 1002 }], "edges": [], "backgroundUrl": "img/bg.ccee1c62.png" }))
            let new_id = uuidv4();
            data = {
              nodes: [
                {
                  id: new_id,
                  type: "icon-theme",
                  x: 355,
                  y: 350,
                  properties: {
                    isShowDelete: false,
                    id: new_id,
                    type: "icon-theme",
                    topic: title != "" ? title : "起始",
                  },
                  zIndex: 1002,
                },
              ],
              edges: [],
              backgroundUrl: "",
            };
            let mindinfo = {
              "us.cscl": [
                {
                  sendId:
                    window.location.href.indexOf("localhost") != -1 ||
                    window.location.href.indexOf("192.168") != -1
                      ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                      : window.parent.US.userInfo.userid, //发送人id
                  receiveId: id, //文件id
                  pageId:
                    window.location.href.indexOf("localhost") != -1 ||
                    window.location.href.indexOf("192.168") != -1
                      ? "d7300d31-8cf6-38dc-e295-2c71622b4df1"
                      : window.parent.US.pageId,
                  type: "update", //消息类型
                  messageInfo: data,
                },
              ],
            };
            let params =
              "mode=" +
              [
                "send",
                encodeURIComponent(
                  encodeURIComponent(JSON.stringify(mindinfo))
                ),
              ].join(",");
            that.$ajax
              .post("https://poll.cocorobo.cn", params)
              .then((res) => {
                console.log(res);
                that.quit(id, loadingInstance);
              })
              .catch((err) => {
                console.error(err);
                loadingInstance.close();
                that.$message({
                  message: err,
                  type: "error",
                });
              });
          }
          // that.quit(id, loadingInstance)
        })
        .catch((err) => {
          console.error(err);
          loadingInstance.close();
          that.$message({
            message: err,
            type: "error",
          });
        });
    },
    quit(id, loadingInstance) {
      let that = this;
      let params =
        window.location.href.indexOf("localhost") != -1 ||
        window.location.href.indexOf("192.168") != -1
          ? "mode=" +
            [
              "quitcscl",
              encodeURIComponent(
                encodeURIComponent(
                  JSON.stringify({
                    docId: id,
                    pageId: "d7300d31-8cf6-38dc-e295-2c71622b4df1",
                    userId: "1cf9dc4b-d95f-11ea-af4c-52540005ab01",
                    type: "cscl",
                  })
                )
              ),
            ].join(",")
          : "mode=" +
            [
              "quitcscl",
              encodeURIComponent(
                encodeURIComponent(
                  JSON.stringify({
                    docId: id,
                    pageId: top.US.pageId,
                    userId: top.US.userInfo.userid,
                    type: "cscl",
                  })
                )
              ),
            ].join(",");
      that.$ajax
        .post("https://poll.cocorobo.cn", params)
        .then(() => {
          // console.log(res.data)
          // if (res.data == "quitcscl") {
          //   console.log(res)
          // }
        })
        .catch((err) => {
          console.error(err);
          loadingInstance.close();
          that.$message({
            message: err,
            type: "error",
          });
        });
    },
    doRegister: function () {
      this.$router.push("/Register");
    },
  },
};
</script>

<style>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 10%;
  /* padding-top: 6%; */
  background-image: url(data:image/svg+xml;base64,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);
  /* background-color: #112346; */
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}

.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  /* width: 380px;
    height: 435px; */
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
</style>
